export default __webpack_public_path__ + "static/media/cpv_45_building-activity.dd2b6359.svg";